module.exports = __webpack_public_path__ + "img/report-enhancement.efc4bc55.svg";